<template>
  <div id="app">
    <header id="header" v-if="user">
      <div class="header-wrap">
          <router-link class="logo" v-bind:to="{ name: 'Hello' }"><img src="./assets/f-und-s-logo.svg" v-on:click=""> <div class="title">F&S</div></router-link>
        <div class="user-box">
          <button v-if="user" class="userButton">User </button> <div v-if="user" class="user">{{user.email}}</div>  
          
          <button v-if="user" v-on:click="logout" class="logoutButton">Logout </button>
        </div>
      </div>
    </header>

   <transition
        name="fade"
        mode="out-in"
      >
      <router-view/>
      </transition>
  </div>
</template>

<script>
import firebase from 'firebase'
  
export default {
  name: 'App',
  data: function(){ 
    return {
      user: null
    }
  },
  methods: {
    logout: function(){
      firebase.auth().signOut().then( () => {
        this.$router.push('/login' )
      })
    }
  },
  created () { 
    firebase.auth().onAuthStateChanged( (user) => { return this.user = user })
  }
}
</script>

<style>
 /*! normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css */
 button,hr,input{overflow:visible}progress,sub,sup{vertical-align:baseline}[type=checkbox],[type=radio],legend{box-sizing:border-box;padding:0}html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:ButtonText dotted 1px}fieldset{padding:.35em .75em .625em}legend{color:inherit;display:table;max-width:100%;white-space:normal}textarea{overflow:auto}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}[hidden],template{display:none}
 
 * {
    -ms-box-sizing: border-box; 
    -o-box-sizing: border-box; 
    -webkit-box-sizing: border-box; 
    -moz-box-sizing: border-box; 
    box-sizing: border-box; 
   	}

 body,html { margin: 0 !important; padding: 0; font-family: "Open Sans", sans-serif; font-weight: 300; font-size: 16px; height: 100%; color: #4a4a4a; }
 
 body { 
/* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#f4f4f4+0,e5e5e5+100 */
/*
background: rgb(244,244,244); 
background: -moz-linear-gradient(-45deg, rgb(244,244,244) 0%, rgb(229,229,229) 100%); 
background: -webkit-linear-gradient(-45deg, rgb(244,244,244) 0%,rgb(229,229,229) 100%); 
background: linear-gradient(135deg, rgb(244,244,244) 0%,rgb(229,229,229) 100%);
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f4f4f4', endColorstr='#e5e5e5',GradientType=1 );
*/
    }

  a { color: #00aeff; text-decoration: none; }

  .textLeft { text-align: left !important; }
  
 #app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #1c2e40;
  margin: 0;
  padding: 3.322333em 0;
  }
  #header { background: #00aeff; padding: 0.633333333em 0.93333333em; box-shadow: 0 0 0 rgba(0,0,0,0.4); position: fixed; top: 0; left: 0; right: 0; z-index: 10; }
  #header img { display: block; width: 2.1333333em; height: 2.1333333em; margin: 0 0 0 0; }
  #header .header-wrap { display: flex; align-items: center; width: 100%; justify-content: space-between; }
  #header .header-wrap .logo { display: flex; align-content: flex-start; align-items: stretch; text-decoration: none; }
  #header .header-wrap .logo .title { background: none; color: #fff; display: inline-block; vertical-align:middle; line-height: 2.03333rem; padding: 0 0.6333333em; font-weight: 600; display: none; }

@media screen and (min-width: 768px) {
  #header .header-wrap .logo .title { display: inline-block; }
}

  #header .header-wrap .user-box { display: flex; align-content: flex-end; align-items: center; }
  #header .header-wrap .user { display: inline-block; padding: 0 0.933333em 0 0.4333333em; background: none; line-height: 2.1333333em; color:#fff; }

  .button { margin: 0.6333333em 0 0 0 ; display: inline-block; height: calc(2.133333em +4px); line-height: 2.1333333em; padding: 0 1.4333333em; border: 2px solid #00aeff; border-radius: 3px; background: #fff; vertical-align: top; cursor: pointer; transition: color 0.3s ease-out, background 0.3s ease-out; outline: 0 !important; }
  .button:hover { background: #00aeff; color: #fff; }
  .button:focus { background: #00aeff; color: #fff; }

  button.logoutButton { display: inline-block; height: calc(2.133333em); line-height: 2.1333333em; padding: 0 0 !important; border: 2px solid transparent; background: #fff url(./assets/icons/exit.svg) center center no-repeat; background-size: 1.63333em 1.6333333em; vertical-align: top; cursor: pointer; transition: color 0.3s ease-out, background-color 0.3s ease-out; margin: 0 !important; width: 2.133333em; min-width: 0; text-indent: -9999px; border-radius: 3px; }
  button.logoutButton:hover, button.loutoutButton:focus { background-color: #d9d9d8; color: #fff; border-radius: 3px; outline: none; }

  button.userButton { display: inline-block; height: calc(2.133333em); line-height: 2.1333333em; padding: 0 0 !important; border: 2px solid transparent; background: #fff url(./assets/icons/user.svg) center center no-repeat; background-size: 1.63333em 1.6333333em; vertical-align: top; cursor: pointer; transition: color 0.3s ease-out, background-color 0.3s ease-out; margin: 0 !important; width: 2.133333em; min-width: 0; text-indent: -9999px; border-radius: 3px; }
  button.userButton:hover, button.userButton:focus { background-color: #d9d9d8; color: #fff; border-radius: 3px; outline: none; }

  
  input { margin: 0.6333333em 0 0 0; min-width: 10em; padding: 0.6333333em 0.93333333em !important; border: 1px solid #d9d9d8; border-radius: 3px; line-height: 1.43333rem; outline: 0 !important; transition: border-color 0.3s; }
  input:focus { border-color: #00aeff; }
  
  .section { padding: 1.9333333333em 0; }
  .columns { display: block; max-width: 48em; margin: 0 auto;  }
  .columns.small-flex { display: flex; align-items: center; }
  .columns.fullwidth { max-width: 100%; }
  .column { padding: 0.9333333333em;  }
 
 	.columns.wrap { flex-wrap: wrap; }
	.columns.stretch { align-items: stretch; }
	.columns.spacebetween { justify-content: space-between; }
	.columns.aligncenter { justify-content: center; align-content: center;}
	.columns.alignTop { align-items: flex-start !important; }
	.columns.alignMiddle { align-items:center !important; }
	
	.columns.alignLeft { justify-content: flex-start; align-content:  flex-start;}

 
  
@media screen and (min-width: 768px) {
	.section { padding: 2.4333333333em 0; }
	.columns.flex { display: flex; align-items: center; }
	.column { padding: 0.9333333333em; }
/* 	.columns.flex .column { flex: 1; } */
	.columns.flex .column.full { width: 100%; flex: 1 1 100%; }
	.column.half { max-width: 50%; flex: 1 1 50%; border: 0 solid red; }
}

@media screen and (min-width: 1024px) {
	.column { position: relative; }
}
  
  
  .backbutton { position: fixed; z-index: 9; left: 0; right: 0; top: 3.33333em; background: #fff; border-bottom: 1px solid #d8d8d9; margin-bottom: 2.7777em; }
  .backbutton .button { margin: 0 !important; border: 0; padding: 0.1111em 0.933333em }
  .backbutton .column { padding: 0.49999em 0.9333333em  !important; text-align: left; }
  
  
.fade-enter-active,
.fade-leave-active {
  transition-delay: 0.2s;
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease-in-out;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}  
  
  
</style>



// WEBPACK FOOTER //
// src/App.vue